export const financialInstitutionRoles = [
  { label: 'Selling location', value: 'Selling location' },
  { label: 'Paying location', value: 'Paying location' },
  { label: 'Both', value: 'Both' }
]
